export default "__VITE_ASSET__9cc428a5__"